<template>
  <div class="row stat-primary stat-charts">
    <div class="col-12 col-md-4" v-for="type in types" :key="type">
      <router-link :to="{ name: links[type] }">
        <ChartCard
          :title="type"
          subtitle="15 days - Pageviews"
          :total="total[type]"
          :data="ga[type]" />
      </router-link>
    </div>
  </div>
</template>

<script>
import filters from '@/mixins/filters'
import ChartCard from '@/components/ChartCard.vue'

export default {
  mixins: [
    filters
  ],
  components: {
    ChartCard
  },
  data: function () {
    return {
      ga: {
        products: null,
        collections: null,
        blogs: null
      },
      total: {
        products: 0,
        collections: 0,
        blogs: 0
      }
    }
  },
  computed: {
    types: function () {
      return ['products', 'collections', 'blogs']
    },
    links: function () {
      return {
        products: 'amp_products',
        collections: 'amp_collections',
        blogs: 'amp_blog_posts'
      }
    },
    chartOptions: function () {
      return { fill: '#fff', stroke: '#2CB1BC', strokeWidth: 2, width: '100%' }
    }
  },
  mounted: async function () {
    this.types.forEach(async pagetype => {
      const data = await this.$API_GET('/analytics/pageviews', { pagetype, _: 1 })

      this.total[pagetype] = data.reduce((acc, val) => acc + val, 0)
      this.ga[pagetype] = data.toString()
    })
  }
}
</script>
